export let ServerName = /*#__PURE__*/function (ServerName) {
  ServerName["prod"] = "prod";
  ServerName["staging"] = "staging";
  ServerName["test1"] = "test-1";
  ServerName["test2"] = "test-2";
  ServerName["test3"] = "test-3";
  ServerName["test4"] = "test-4";
  ServerName["test5"] = "test-5";
  ServerName["test6"] = "test-6";
  ServerName["test7"] = "test-7";
  ServerName["test8"] = "test-8";
  ServerName["test9"] = "test-9";
  ServerName["testAuto"] = "test-auto";
  ServerName["testIts"] = "test-its";
  ServerName["test11"] = "test-11";
  ServerName["development"] = "development";
  return ServerName;
}({});